import { baseStyle } from './app.style'
import { Div } from './base/components/native/div'
import router from './base/lib/router'
import { HomePage } from './pages/home'
import { BackIcon } from './components/shared/back-icon'
import { MenuIcon } from './components/shared/menu-icon'

const view = Div()
const app = Div()
const menuIcon = MenuIcon()
const backIcon = BackIcon()
app.append(view)
app.cssClass(baseStyle)

const routes = {
    '/': HomePage,
}

router.init({ routes, view })

export default app